// https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses

export enum UISearchStatusMappingEnum {
  PAYMENT_IN_PROCESS = <any>'paymentInProcess',
  UNPAID = <any>'unpaid',
  PAID = <any>'paid',
  CANCELLED = <any>'cancelled'
}




// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/ui-search-status-mapping-enum.ts